import cmmnRoutes from "@/router/items/common/cmmnRoutes";
import inhaInfoRoutes from "@/router/items/common/inhaInfoRoutes";
import commuRoutes from "./CommuRouter";
import PlatformRoutes from "./PlatformRoutes";
import GqfLayoutRoutes from "./GqfLayoutRoutes";
import diagRoutes from "./DiagRoutes";
import ecpRoutes from "./EcpRoutes";
import mainRoutes from "./MainRoutes";
import mypageRoutes from "./MypageRoutes";

/**
 * meta: {
 *   requiresAuth: true  // 로그인 필요
 *   noCaching: true     // 캐싱 방지
 *   isDynamic: true     // 동적 라우트 (메뉴 권한 체크)
 *   menuCd: string      // 메뉴 코드
 *   title: string       // 국문 타이틀
 *   - 모바일 헤더 관련
 *   mobileTitle: string // 모바일 헤더 타이틀
 *   mobileHd: true      // 모바일 헤더 별도 적용
 *   likeBtn: true       // 모바일 헤더에 찜하기 버튼 노출
 *   homeBtn: true       // 모바일 헤더에 홈 버튼 노출
 *   gnbBtn: true        // 모바일 헤더에 메뉴 버튼 노출
 *   site: 'inha'        // 영산대 페이지
 * }
 */

const studentRoutes = [
  {
    path: "",
    name: "index",
    redirect: { name: "student" },
  },
  {
    path: "/",
    name: "student",
    meta: {
      title: "학생 화면",
      noCaching: true,
    },
    redirect: { name: "studentMain" },
    component: () => import("@/layout/LayoutMain.vue"),
    children: [
      {
        path: "/onlyDainIndex",
        meta: { title: "로그인", mobileTitle: "로그인", mobileHd: true },
        component: () => import("@/views/common/login/CommonLogin.vue"),
      },
      {
        path: "/login",
        meta: { title: "로그인", mobileTitle: "로그인", mobileHd: true },
        component: () => import("@/views/common/login/CommonLogin.vue"),
      },
      {
        path: "/signup",
        meta: {
          title: "회원가입",
          mobileTitle: "회원가입",
          isDynamic: false,
        },
        component: () => import("@/views/common/login/OtsdrSignup.vue"),
      },

      ...mainRoutes, // 메인 라우트
      ...ecpRoutes, // 비교과 라우트
      ...commuRoutes,
      ...PlatformRoutes, //평생학습플랫폼
      ...GqfLayoutRoutes, //GQF 소개
      ...diagRoutes, // 역량진단 라우트
      ...mypageRoutes, // 마이페이지
      ...inhaInfoRoutes, // 영산대 사업소개 라우트
    ],
  },
  {
    path: "/print-preview",
    meta: {
      auth: false,
      noCrumb: true,
    },
    component: () => import("@/components/base/PrintPreview.vue"),
  },
  ...cmmnRoutes, // 공통 라우트
];
export default studentRoutes;
